import { render } from "./DisabledTable.vue?vue&type=template&id=5a337495&scoped=true&ts=true"
import script from "./DisabledTable.vue?vue&type=script&lang=ts"
export * from "./DisabledTable.vue?vue&type=script&lang=ts"

import "./DisabledTable.vue?vue&type=style&index=0&id=5a337495&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a337495"]])

export default __exports__